import { render, staticRenderFns } from "./add-base-info.vue?vue&type=template&id=432c33ca&scoped=true&"
import script from "./add-base-info.vue?vue&type=script&lang=js&"
export * from "./add-base-info.vue?vue&type=script&lang=js&"
import style0 from "./add-base-info.vue?vue&type=style&index=0&id=432c33ca&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c33ca",
  null
  
)

export default component.exports